// extracted by mini-css-extract-plugin
module.exports = {"formulario":"form_formulario__fd1xn","boton":"form_boton__3htsi","inputDuracion":"form_inputDuracion__1rwVy","lista":"form_lista__2iz06","listado":"form_listado__yZcd4"};